import { dataHouse } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHouse = /*#__PURE__*/createIcon(dataHouse)
export default IconHouse
